const STORAGE_KEY = 'obusinesscard_locale';

export const SUPPORTED_LOCALES: string[] = ['en', 'ar', 'es', 'fr', 'zh'];

let currentLocale: string = 'en';
let translations: Record<string, any> = {};
let listeners: Array<() => void> = [];

function readStoredLocale(): string {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored && SUPPORTED_LOCALES.includes(stored)) {
      return stored;
    }
  } catch {}
  return 'en';
}

currentLocale = readStoredLocale();

function getNestedValue(obj: Record<string, any>, key: string): string | undefined {
  const parts = key.split('.');
  let current: any = obj;
  for (const part of parts) {
    if (current == null || typeof current !== 'object') return undefined;
    current = current[part];
  }
  return typeof current === 'string' ? current : undefined;
}

function interpolate(template: string, params?: Record<string, any>): string {
  if (!params) return template;
  return template.replace(/\{(\w+)\}/g, (_, key) => {
    return params[key] !== undefined ? String(params[key]) : `{${key}}`;
  });
}

export async function loadLocale(lang: string): Promise<void> {
  if (!SUPPORTED_LOCALES.includes(lang)) {
    console.warn(`Locale "${lang}" is not supported. Falling back to "en".`);
    lang = 'en';
  }

  const module = await import(`./locales/${lang}.json`);
  translations = module.default || module;
  currentLocale = lang;

  try {
    localStorage.setItem(STORAGE_KEY, lang);
  } catch {}
}

export function t(key: string, params?: Record<string, any>): string {
  const value = getNestedValue(translations, key);
  if (value === undefined) {
    return key;
  }
  return interpolate(value, params);
}

export function getLocale(): string {
  return currentLocale;
}

export function setLocale(lang: string): void {
  if (!SUPPORTED_LOCALES.includes(lang)) return;
  loadLocale(lang).then(() => {
    listeners.forEach((fn) => fn());
  });
}

export function subscribe(listener: () => void): () => void {
  listeners.push(listener);
  return () => {
    listeners = listeners.filter((fn) => fn !== listener);
  };
}
